import { render } from "./CRMWhatsappConversationsView.vue?vue&type=template&id=0d723040&scoped=true"
import script from "./CRMWhatsappConversationsView.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappConversationsView.vue?vue&type=script&lang=js"

import "./CRMWhatsappConversationsView.vue?vue&type=style&index=0&id=0d723040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d723040"]])

export default __exports__